/** What every field but sign-in says to the browser's autofill: nothing here is
 *  about the person typing. A customer's phone, a colleague's name, a stage, a
 *  site — the office is entering the shop's records, and a box offering their
 *  own home address over the field is in the way of every one of them.
 *
 *  `off` is the spec's word for it, and Chromium is the one engine that ignores
 *  it: it keeps offering saved addresses on an `off` field, on purpose. What it
 *  does honour is a value it does not recognise, which it takes as the page
 *  saying this is not an address field. So Chrome and Edge get that, and every
 *  other engine keeps `off`, which they read the way it is written — an
 *  unrecognised value there is just autofill left on.
 *
 *  Put it on every `input`, `textarea` and `select` you add. The smoke test
 *  collects every field the run draws and fails on one without it. */
export const NO_AUTOFILL =
  typeof navigator !== 'undefined' && /\b(?:Chrome|CriOS|EdgiOS)\//.test(navigator.userAgent)
    ? 'shop-record'
    : 'off';
